export default __webpack_public_path__ + "static/media/Thumb_Facial_Hair_07.bc71d033.png";